import * as PIXI from "pixi.js";
import Game from "../../Game";
import Layers from "../../layers/Layers";
import Switcher from "./Switcher";
import { rootEventBus, EnumRootEventBus } from "../../managers/RootEventBus";
import { Coord } from "../../types/Interface";


type SwitcherContainerProps = {
	header: string,
	coords: { vertical: Coord, horizontal: Coord },
	handleFunc: (v: boolean) => void
}


export default class SwitcherContainer extends PIXI.Container {
	private Game = Game.getInstance();
	private Layers = Layers.getInstance();
	Switcher!: Switcher;
	Header!: PIXI.Text;
	coords: {
		vertical: Coord,
		horizontal: Coord
	}
	handleFunc: (v: boolean) => void;
	constructor({ header, coords, handleFunc }: SwitcherContainerProps) {
		super();
		this.coords = coords;
		this.handleFunc = handleFunc;
		this.addHeader(header);
		this.addCoord();
		this.addSwitcher();
		this.addToLayer();

		rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => this.setVisible(false));
		rootEventBus.on(EnumRootEventBus.completedCircleAnim, () => this.setVisible(true));
	}

	setVisible = (v: boolean) => this.visible = v;
	addToLayer = () => this.Layers.UI.addChild(this);
	addCoord() {
		const dim = this.Game.getDim();
		let coord = this.coords.horizontal;
		if (dim.WIDTH < dim.HEIGHT) {
			coord = { x: dim.WIDTH / 2 + this.coords.vertical.x, y: dim.HEIGHT / 2 + this.coords.vertical.y };
		}
		Object.assign(this, coord);
	}
	addHeader(header: string) {
		this.Header = new PIXI.Text({ text: header });
		this.Header.anchor.set(.5);
		this.Header.x = 0;
		this.Header.y = -32;
		this.addChild(this.Header);
	}
	addSwitcher() {
		const dim = this.Game.getDim();
		this.Switcher = new Switcher(0x55E39F, this.handleFunc, true);
		this.Switcher.scale.set(dim.WIDTH > dim.HEIGHT ? 1.3 : 1.9);
		this.Switcher.x = 0;
		this.Switcher.y = 0;
		this.addChild(this.Switcher);
	}
	getActivationStatus = () => this.Switcher.getActive();
	setActivation(v: boolean) {
		const isActive = this.Switcher.getActive()
		if (v && isActive) this.Switcher.handleSwitcher(!isActive);
	}
}